import { useState, useCallback } from "react";

const useMutation = ({
  mutationFn = async () => {},
  onSuccess = () => {},
  onError = () => {},
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  function clearData() {
    setData(null);
  }

  const mutate = useCallback(
    async (variables) => {
      setIsLoading(true);
      setError(null);

      try {
        const result = await mutationFn(variables);
        setData(result);
        onSuccess?.(result);
        return result;
      } catch (err) {
        setError(err);
        onError?.(err);
        return err;
      } finally {
        setIsLoading(false);
      }
    },
    [mutationFn, onSuccess, onError]
  );

  return { mutate, clearData, isPending: isLoading, data, error };
};

export default useMutation;
